import Layout from "@/components/Layout";
import ProjectsListPage from "@/pages/ProjectsListPage";
import { useTour } from "@reactour/tour";
import { withTour } from "@/components/withTour";
import { useTranslation } from "react-i18next";

const useTourSteps = () => {
  const { t } = useTranslation();
  return [
    {
      selector: '#page-title',
      content: t('projects.tour.welcome'),
      position: 'bottom',
    },
    {
      selector: '#video-url-input',
      content: t('projects.tour.urlInput'),
      position: 'left',
    },
    {
      selector: '#video-file-input',
      content: t('projects.tour.fileInput'),
      position: 'right',
    },
    {
      selector: '#project-history-title',
      content: t('projects.tour.projectHistory'),
      position: 'top',
    },
    {
      selector: '#help-button',
      content: t('projects.tour.helpButton'),
      position: 'bottom',
    },
  ];
};

const ProjectsContent = () => {
  const { setIsOpen, setCurrentStep } = useTour();

  const startTour = () => {
    setCurrentStep(0);
    setIsOpen(true);
  };

  return (
    <Layout
      onStartTour={startTour}
    >
      <ProjectsListPage />
    </Layout>
  );
};

const ProjectsWrapper = () => {
  const tourSteps = useTourSteps();
  const WrappedComponent = withTour(ProjectsContent, 'autoclipper-tour-seen', tourSteps);
  return <WrappedComponent />;
};

const Projects = ProjectsWrapper;

export default Projects;



